import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
			<div style="text-align: justify;">

				<p class="mb-3">
					Hodiaŭ mi ricevis novan interesan taskon: elbredi memekstermantan estaĵon. 
					Antaŭe ni okazigis tiajn esplorojn en universa skalo: produktis planedon, kiu evoluis ĝis certa grado, 
					kaj poste memekstermis lasante por ni kelkajn utilajn substancojn, kiujn estus neoportune aŭ pli multekoste ricevi alimaniere. 
					Tamen, kelkaj tiaj provoj fiaskis per eksplodo aŭ eligo de tute ne utilaj kaj eĉ nocaj substancoj. 
					Tial la gvidantaro de nia esplorinstituto decidis fermi tiun direkton kaj transiri al pli multpromesa problemo: 
					kreado de konstantaj planedoj kun ŝanĝebla loĝantaro, kiu produktos bezonatajn substancojn en certaj kvantoj dum certa tempodaŭro, 
					kaj poste memekstermiĝos, liberigante la medion por novaj enloĝantoj. 
					La metodo multe pli prudenta kaj ŝparema.
				</p>

				
				<p class="bold text-center mb-3 mt-3">* * *</p>
				
				
				<p class="mb-3">
					Post kelkaj provoj rezultiĝis vertikala organika estaĵo, kapabla memstare multobliĝi kaj produkti el la ĉirkaŭa medio certajn utilajn por ni substancojn, ekz., 
					ureo, indolo kaj skatolo, ege malpli koste ol se ni provus sintezigi ilin. 
					Post ricevo de sufiĉa kvanto da substanco la programita konduto enŝaltiĝas – kaj la estaĵoj liberigas la surfacon de sia planedo por nova populacio, 
					produktanta novajn necesajn al ni aĵojn. 
					Tute simple kaj facile.
				</p>
				
				<p class="mb-3">
					Dum la tempo de sia ekzistado la populacio formas en si mem iujn rilatojn, nociojn, inkl. rilate sin mem kaj sia loko en la Kosmo. 
					Kompreneble, ili opinias sin la krono de kreaĵoj, sed tamen serĉas, kiu ja kreis ilin. 
					Foje mi por amuzo konektiĝas al ilia komuna menso kaj aŭskultas, kiel ili nomas min: Alaho, Jehovo, Cebaoto, Enlilo… 
					kaj multaj, multaj aliaj vortoj. 
					Kiel bone, ke ni, doninte al ili konscion, limigis ĝin al la eblo esplori kaj ŝanĝi nur la ĉirkaŭan mondon, sed ne sin mem. 
					La esploro de sia propra cerbo, siaj deziroj kaj streboj ne eblas por ili. 
					Aliel ili fariĝus memstaraj, ne plu submetus sin al nia kontrolo. kaj ne plenumus la agojn, por kiuj ili estis kreitaj. 
					Sed por kio ili tiam estus bezonataj?
				</p>

				
				<p class="bold text-center mb-3 mt-3">* * *</p>
				
				
				<p class="mb-3">
					Mi okupiĝas pri kreado de virusoj. 
					La temo estas tre multpromesa, donanta vastegajn perspektivojn en diversaj sferoj de vivo. 
					Ne nur en genetiko kaj medicino, kiel opinias multaj; ekz., 
					ni en nia branĉo okupiĝas pri kreado de nanomaterialoj surbaze de virusoj por molekula elektroniko, 
					kie virusoj funkcias kiel portantoj aŭ kiel ŝablonoj por krei novajn materialojn. 
					Niaj artefaritaj virusoj, diference de la naturaj, estas facile elimineblaj: endas nur distranĉi iliajn DNA-ĉenojn, 
					kion ni jam delonge scipovas fari. 
					Jam ne malproksimas la tempo, kiam ni same facile povos ekstermi naturajn malsanigajn virusojn. 
					Tio estos grandega venko de la Homo super Naturo. 
				</p>

				
				<p class="bold text-center mb-3 mt-3">* * *</p>
				
				
				<p class="mb-3">
					La Nobelpremion pri medicino en la jaro 2*** gajnis XXX YYY el ZZZ pro malkovro de metodo de malaktivigo de naturaj malsanigaj virusoj. 
					Dum la pasintaj jardekoj fantaste kreskis la bonstato de l’ homaro, liberigita de malsanoj ne nur propraj, sed ankaŭ de tiuj, 
					kiuj atakas animalojn kaj vegetaĵojn bezonatajn por Homo. 
					Fin-fine la homa vivo ĉesis dependi de hazardaj faktoroj kaj jam apartenas nur al li mem!
				</p>

				
				<p class="bold text-center mb-3 mt-3">* * *</p>
				
				
				<p>
					Okaze de sukcesa finiĝo de la projekto pri kreado de memekstermanta estaĵo produktanta la substancojn A, B kaj C, lige kun eltrovo de alia, 
					pli ekonomie profita metodo de ricevado de tiuj substancoj, 
				</p>
				<p class="mb-3">
					NI DECIDIS:
				</p>				
				<p>
					a) Realigi la programon de memekstermo de tiuj estaĵoj sur la esplorkampo ₡₩‡
				</p>				
				<p>
					b) Plene rasti, purigi kaj desinfekti la nomitan esplorkampon ₡₩‡
				</p>				
				<p>
					c) Pri la plenumo raporti
				</p>				
				
      
				<table class="m-lg-3" style="width: 100%;">
					<tr>
						<td>Subskribo:</td>
						<td>Sigelo:</td>
					</tr>
				</table>

				
				<p class="bold text-center mb-3 mt-3">* * *</p>
				
				
				<p class="mb-3">
					El la raporto de la mekanismo NPG:
				</p>
				
				<p class="mb-3">
					… rezulte de okazigitaj aranĝoj estas forigitaj organikaj estaĵoj, kiuj realigis eksperimentojn pri kreo kaj apliko de aliaj organikaj estaĵoj, okupintaj la teritoriojn nature destinitajn por disvolvo kaj evoluo de neorganika formo de ekzistado kiel la supera formo de ekzistado de materio kaj energio. 
				</p>
				
				<p class="mb-3">
					Tiamaniere, la vivareo por nia civilizacio jam estas rastita kaj atendas nin. 
				</p>

				<p class="mb-3">
					GLORON AL NI!
				</p>

			</div>
    `
  )
}

const itemName = {
  esp: 'Ŝtupoj de ekkono'
}

const itemDate = {
	esp: '23-an de oktobro 2023'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
		itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 